import { ShutdownStatus, State } from '@repo/sdk/models/components';

import { UseWebsocketQueryOptions } from '@/hooks/query-hooks/websockets';
import { QueryToast } from '@/queries/types';

export const shutdownBannerStreamQuery = (
  agentId: string | undefined
): UseWebsocketQueryOptions<ShutdownStatus | null> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'shutdown-banner'],
    staleTime: Infinity,
    meta: {
      toast: {
        severity: 'off',
      } as QueryToast,
    },
    webSocketUrl: `/bff/v1/agents/${agentId}/shutdown-banner-stream`,
    initialData: {
      state: State.Idle,
    },
  };
};
